"use client";

import { Typography } from "@/components/ui/typography";
import * as images from "@/components/images/Images";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { memo } from "react";
import { AboutUsTeamProps } from "./types";

const AboutUsHero = ({ className, ...rest }: AboutUsTeamProps) => {
  return (
    <section className={className} {...rest}>
      <div className="relative md:px-6">
        <div className="flex absolute inset-0 before:absolute before:inset-0 before:bg-gradient-to-b before:from-black/0 before:to-black/60">
          <Image
            src={images.aboutUsTeam}
            width={4096}
            height={1927}
            alt="About Us Team"
            className="w-full h-full object-cover object-[40%_50%] flex-auto min-w-0"
          />
        </div>
        <div className="container mx-auto relative z-[1]">
          <div className="py-7 px-[2.875rem] h-[662] md:px-0 lg:h-[677] md:py-20 flex items-center md:items-end text-white">
            <Typography
              variant="heading4"
              className="text-white lg:leading-[130%] lg:font-normal lg:text-[50px]"
            >
              <h2>
                Our vision is to make meaningful connections in every language
                and create a world where language is never a barrier to business
                success.
              </h2>
            </Typography>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(AboutUsHero);
